module.exports = __webpack_public_path__ + "static/Waving Flag-Small-a5ca4a8444365d13d69ab8a0d3fe71a7.png";